'use client'

import { toLogout } from '@/feature/auth/services/auth.routing'
import { APOLLO_CLIENT_SIDE_OPTIONS } from '@/lib/apollo/clients/apolloClient.client'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { useNextIsClientHydrated } from '@/lib/next/useNextIsClientHydrated'
import { Button } from '@/ui/buttons/button/Button.client'
import { Icon } from '@/ui/icons/icon/Icon'
import { PreHeaderBanner } from '@/ui/pre-header-banner/PreHeaderBanner'
import { TextSkeleton } from '@/ui/skeleton/TextSkeleton'
import { useQuery } from '@apollo/client'
import { gql } from '@gql-generated/gql'

const IMPERSONATION_BANNER_QUERY = gql(/* GraphQL */ `
  query ImpersonationBanner {
    currentUser {
      id
      company {
        id
        code
        name
      }
    }
  }
`)

export function ImpersonationBanner() {
  const { t } = useTranslation(['impersonationBanner'])
  const isHydrated = useNextIsClientHydrated()
  const { data, loading } = useQuery(IMPERSONATION_BANNER_QUERY, {
    ...APOLLO_CLIENT_SIDE_OPTIONS,
    skip: !isHydrated || APOLLO_CLIENT_SIDE_OPTIONS.skip,
  })

  const company = data?.currentUser?.company
  const companyLabel = company ? `${company.name} • ${company.code}` : ''

  const handleCloseSession = () => {
    window.location.href = toLogout
  }

  const handleChangeAccount = () => {
    window.location.href = '/internal/login-as/logout'
  }

  const isLoading = !isHydrated || loading

  return (
    <PreHeaderBanner>
      <Button
        size="md"
        variant="link"
        iconLeft={<Icon.LogOut size="sm" />}
        onPress={handleCloseSession}
      >
        {t('impersonationBanner:impersonation.closeSession')}
      </Button>
      <div className="flex items-center gap-1">
        {isLoading ? (
          <TextSkeleton size="sm" leading="normal" className="w-20" />
        ) : companyLabel ? (
          <div className="hidden select-none text-md tablet:block">{companyLabel}</div>
        ) : null}
        <Button
          size="md"
          variant="link"
          iconLeft={<Icon.RefreshCw size="sm" />}
          onPress={handleChangeAccount}
        >
          {t('impersonationBanner:impersonation.changeAccount')}
        </Button>
      </div>
    </PreHeaderBanner>
  )
}
